<template>
  <div class="data-migration-instructions">
    <common-bg-plate>
      <detail-section title="如何使用数据迁移">
        <div class="instructions-info">
          <div class="instructions-content">
            <template v-for="(item, index) in steps">
              <div :key="index" class="instructions-item">
                <div class="instructions-icon">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="instructions-text">{{ item.title }}</div>
              </div>
              <div
                v-if="index < steps.length - 1"
                :key="`vector${index}`"
                class="instructions-vector"
              >
                <div class="instructions-vector-icon"></div>
              </div>
            </template>
          </div>
          <div class="instructions-btns">
            <btn-style :btn-list="btnList"></btn-style>
          </div>
        </div>
      </detail-section>
      <download-dialog
        :dialog-visible.sync="showDownloadDialog"
        title="下载数据迁移服务部署包"
        :file-url="downloadUrl"
        :file-name="downloadFileName"
        :store-file-name="storeFileName"
        :meta-data="downloadMetaData"
      ></download-dialog>
    </common-bg-plate>
  </div>
</template>

<script>
import stepDownloadIcon from '@/assets/images/datamigration/step-download-icon.png'
import stepDeployIcon from '@/assets/images/datamigration/step-deploy-icon.png'
import stepConfigIcon from '@/assets/images/datamigration/step-config-icon.png'
import stepMigrationIcon from '@/assets/images/datamigration/step-migration-icon.png'
import stepStopServiceIcon from '@/assets/images/datamigration/step-stop-service-icon.png'

export default {
  name: 'Instructions',
  components: {},
  data() {
    return {
      btnList: [
        {
          btnContent: '下载部署包',
          click: () => {
            return this.downloadDeploymentPackage()
          },
          icon: 'icon-download'
        }
      ],
      steps: [
        {
          title: '下载资源包',
          icon: stepDownloadIcon
        },
        {
          title: '部署',
          icon: stepDeployIcon
        },
        {
          title: '添加服务器配置',
          icon: stepConfigIcon
        },
        {
          title: '开始迁移',
          icon: stepMigrationIcon
        },
        {
          title: '结束服务',
          icon: stepStopServiceIcon
        }
      ],
      //下载对话框
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: '',
      storeFileName: () => '数据迁移服务部署脚本.sh',
      downloadMetaData: {}
    }
  },
  methods: {
    downloadDeploymentPackage() {
      this.downloadUrl = `/cbaas-service/v1/dataTransfer/download`
      this.downloadFileName = `数据迁移服务部署脚本.sh`
      this.downloadMetaData = {}
      this.showDownloadDialog = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'data-migration-instructions',
  (
    --instructions-vector-image: url('~@/assets/images/excellent/small-vector-dark.png'),
    --data-migration-instructions-color: #ffffff,
    --data-migration-instructions-background-color: #354274
  ),
  (
    --instructions-vector-image: url('~@/assets/images/excellent/small-vector-light.png'),
    --data-migration-instructions-color: #192227,
    --data-migration-instructions-background-color: #f6f7f9
  )
);
.data-migration-instructions {
  @include adaptation(
    (
      --data-migration-instructions-height: 323px,
      --data-migration-instructions-content-margin-top: 8px,
      --data-migration-instructions-content-margin-padding: 0 84px,
      --data-migration-instructions-content-item-width: 96px,
      --data-migration-instructions-content-item-icon-size: 96px,
      --data-migration-instructions-content-item-margin-bottom: 29px,
      --data-migration-instructions-content-item-padding: 20px,
      --data-migration-instructions-content-item-icon-img-size: 56px,
      --data-migration-instructions-content-font-size: 18px,
      --data-migration-instructions-content-line-height: 26px,
      --data-migration-instructions-content-vector-margin-top: 40px,
      --data-migration-instructions-content-vector-height: 16px,
      --data-migration-instructions-content-vector-line-height: 2px,
      --data-migration-instructions-content-vector-line-margin-left: -8px,
      --data-migration-instructions-content-vector-line-margin-right: -8px,
      --data-migration-instructions-btns-margin-top: 40px,
      --data-migration-instructions-btns-margin-bottom: 16px,
      --data-migration-instructions-content-vector-font-size: 16px
    )
  );
  .common-bg-plate {
    min-height: var(--data-migration-instructions-height);
    height: var(--data-migration-instructions-height);

    .instructions-content {
      display: flex;
      justify-content: space-between;
      margin-top: var(--data-migration-instructions-content-margin-top);
      padding: var(--data-migration-instructions-content-margin-padding);

      .instructions-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--data-migration-instructions-color);
        width: var(--data-migration-instructions-content-item-width);

        .instructions-icon {
          width: var(--data-migration-instructions-content-item-icon-size);
          height: var(--data-migration-instructions-content-item-icon-size);
          background-color: var(--data-migration-instructions-background-color);
          border-radius: 50%;
          margin-bottom: var(--data-migration-instructions-content-item-margin-bottom);
          padding: var(--data-migration-instructions-content-item-padding);
          position: relative;

          & img {
            width: var(--data-migration-instructions-content-item-icon-img-size);
            height: var(--data-migration-instructions-content-item-icon-img-size);
          }
        }

        .instructions-text {
          font-size: var(--data-migration-instructions-content-font-size);
          font-weight: 500;
          height: var(--data-migration-instructions-content-line-height);
          line-height: var(--data-migration-instructions-content-line-height);
          white-space: nowrap;
        }
      }

      .instructions-vector {
        width: 100%;
        margin-top: var(--data-migration-instructions-content-vector-margin-top);
        position: relative;
        display: flex;
        height: var(--data-migration-instructions-content-vector-height);
        align-items: center;
        color: var(--data-migration-instructions-background-color);

        .instructions-vector-icon {
          background-image: var(--instructions-vector-image);
          background-size: 100% 100%;
          width: var(--base-size-16);
          height: var(--base-size-16);
          left: calc(50% - var(--base-size-8));
          position: absolute;
          z-index: 1;
        }

        &::before,
        &::after {
          height: var(--data-migration-instructions-content-vector-line-height);
          width: 100%;
          background-color: var(--data-migration-instructions-background-color);
          content: '';
          margin-left: var(--data-migration-instructions-content-vector-line-margin-left);
          margin-right: var(--data-migration-instructions-content-vector-line-margin-right);
        }
      }
    }

    .instructions-btns {
      margin-top: var(--data-migration-instructions-btns-margin-top);
      margin-bottom: var(--data-migration-instructions-btns-margin-bottom);

      .cbaas-btn-style {
        justify-content: center;
      }
    }
  }
}
</style>
